import { render, staticRenderFns } from "./unEvaluateMerchantList.vue?vue&type=template&id=4fd72c64&scoped=true"
import script from "./unEvaluateMerchantList.vue?vue&type=script&lang=ts"
export * from "./unEvaluateMerchantList.vue?vue&type=script&lang=ts"
import style0 from "./unEvaluateMerchantList.vue?vue&type=style&index=0&id=4fd72c64&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd72c64",
  null
  
)

export default component.exports